import {
    ChapterEnum,
    LimitDistributionMethodEnum,
    OtherCostCalculationTypeEnum,
    Uerc_LimitDistributionMethodEnum as UercLimitDistributionMethodEnum,
} from 'gql/graphql';

import type { CSSProperties } from 'react';

import type { TabType } from './types';
import { TabId } from './types';

export const TAB_ITEMS: TabType[] = [
    { label: 'Общие данные', id: TabId.Common },
    { label: 'Лимиты по договору', id: TabId.Limits },
    { label: 'Формула', id: TabId.Formula },
];

export const InvisibleStyle: CSSProperties = {
    visibility: 'hidden',
    position: 'absolute',
    overflow: 'hidden',
    maxHeight: 0,
};

export const CalculationMethodMap: Record<OtherCostCalculationTypeEnum, string> = {
    [OtherCostCalculationTypeEnum.Calculation]: 'Расчет',
    [OtherCostCalculationTypeEnum.Percent]: '%',
};

export const ChapterMap: Record<ChapterEnum, string> = {
    [ChapterEnum.Chapter1_7]: 'Главы 1-7',
    [ChapterEnum.Chapter8]: 'Глава 8',
    [ChapterEnum.Chapter9]: 'Глава 9',
    [ChapterEnum.LimitedCosts]: 'Лимитированные',
    [ChapterEnum.Others]: 'Прочие',
};

export const UerDistributionMethodMap: Partial<Record<UercLimitDistributionMethodEnum, string>> = {
    [UercLimitDistributionMethodEnum.Auto]: 'Автоматически',
    [UercLimitDistributionMethodEnum.EvenlyBySeason]: 'Равномерно',
    [UercLimitDistributionMethodEnum.FirstSeason]: 'Первый сезон',
    [UercLimitDistributionMethodEnum.LastSeason]: 'Последний сезон',
    [UercLimitDistributionMethodEnum.Manual]: 'Вручную',
};

export const DistributionMethodMap: Partial<Record<LimitDistributionMethodEnum, string>> = {
    [LimitDistributionMethodEnum.EvenlyBySeason]: 'Равномерно',
    [LimitDistributionMethodEnum.File]: 'Из файла',
    [LimitDistributionMethodEnum.FirstSeason]: 'Первый сезон',
    [LimitDistributionMethodEnum.LastSeason]: 'Последний сезон',
    [LimitDistributionMethodEnum.Manual]: 'Вручную',
};
